import React from "react";

// Real looping cinematic hero background video (generated stills + ffmpeg motion).
export default function HeroVideo() {
  return (
    <div className="absolute inset-0 overflow-hidden bg-ink" aria-hidden="true" data-testid="hero-video">
      <video
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
        poster="/hero-poster.jpg"
        className="absolute inset-0 h-full w-full object-cover opacity-80"
      >
        <source src="/hero.mp4" type="video/mp4" />
      </video>
      {/* Readability scrims */}
      <div className="absolute inset-0 bg-gradient-to-r from-[#050505] via-[#050505]/75 to-[#050505]/20" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,transparent_0%,rgba(5,5,5,0.45)_82%,#050505_100%)]" />
    </div>
  );
}
